<template>
  <v-dialog v-model="open" class="modalManutencao" persistent max-width="640">
    <v-card class="modal-content">
      <v-btn class="close" icon @click="onDismiss" :aria-label="'Fechar'">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      <v-card-text class="modal-body text-center">
        <v-img src="../assets/manut_2410.png" contain class="mx-auto" />
      </v-card-text>
      <v-card-actions class="modal-footer justify-center pb-6">
        <v-btn color="primary" depressed large @click="onDismiss">Entendi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ManutencaoModal',
  props: {
    maintenanceStart: { type: [String, Date], required: true },
    announceUntil:    { type: [String, Date], required: true },
    storageKey:       { type: String, required: true }
  },
  data() {
    return { open: false };
  },
  mounted() {
    if (this.shouldShow()) this.open = true;
  },
  methods: {
    parseToDate(v) {
      return v instanceof Date ? v : new Date(v);
    },
    shouldShow() {
      // evita erro em navegação privada/sanduíches de política
      try {
        if (localStorage.getItem(this.storageKey) === '1') return false;
      } catch (e) { void 0; } // <- no-op para satisfazer eslint(no-empty)

      const now   = new Date();
      const start = this.parseToDate(this.maintenanceStart);
      const end   = this.parseToDate(this.announceUntil);
      return now >= start && now <= end;
    },
    onDismiss() {
      try {
        localStorage.setItem(this.storageKey, '1');
      } catch (e) { void 0; } // <- no-op

      this.open = false;
      this.$emit('dismissed');
    }
  }
};
</script>

